import {
  Icons
} from '@codev/helix-react';
import PropTypes from 'prop-types';
import React from 'react';
import schemeNames from '../schemeNames.js';
import translations from './translations.js';

const View = ({
  language = 'en_US',
  schemeType,
  style,
  useForRecovery,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      fontSize: '16px',
      textAlign: 'center',
      ...style
    }}
  >
    <div
      style={{position: 'relative'}}
    >
      <Icons.Checkmark
        style={{
          fill: '#FAFAFA',
          fontSize: '24px',
          position: 'absolute',
          marginTop: '36px',
          marginLeft: '22px',
        }}
      />
      <Icons.Lock
        style={{
          fontSize: '70px',
          fill: '#333333',
        }}
      />
    </div>
    <h3 style={{paddingTop: '12px', paddingBottom: '20px', margin: '0px'}}>
      {translations(`stepSuccessMessage${useForRecovery ? 'ForRecovery' : ''}`, language)}
    </h3>
    <div>
      {translations(`stepText${useForRecovery ? 'ForRecovery' : ''}`, language)}
    </div>
    {
      schemeType === schemeNames.googleAuth &&
      <div>
        {translations('stepTextApp', language)}
      </div>
    }
    {
      schemeType === schemeNames.sms &&
      <div>
        {translations('stepTextSms', language)}
      </div>
    }
  </div>
);

View.defaultProps = {
  useForRecovery: false,
};

View.propTypes = {
  schemeType: PropTypes.oneOf([
    schemeNames.googleAuth,
    schemeNames.sms,
  ]).isRequired,
  style: PropTypes.object,
  useForRecovery: PropTypes.bool,
};

export default View;